module.exports = __webpack_public_path__ + "img/google20.2a12a1e5.jpg";